import React from "react"
import * as I from "../Input";

export type HiddenProps = I.InputProps;
const Hidden: React.FC<HiddenProps> = props => <></>;
export default Hidden;